import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';
import { PayDetails } from '@types';
import { isEmpty } from 'lodash';

export const selectPayHistory = (state: RootState) => state.payHistory;

export const selectPayment = createSelector([selectPayHistory], payHistory => {
    if (!isEmpty(payHistory?.Payments)) {
        return payHistory.Payments.find((pay: PayDetails) => {
            const description = pay.Description.toLowerCase();
            if (!description.match('payment reversal')) {
                return description.includes('payment');
            }
        });
    }
});
